"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppLogoFromLinkRecord = exports.getAppLogoFromUrl = exports.getAppLogoFromFilename = exports.getActivityLogoFilePathInMode = exports.getLogoFilePathInMode = exports.getLogoFilePath = exports.getAppName = exports.getAppLogo = exports.getFileExtension = exports.getAppFromMimeType = exports.getAppFromUrl = exports.createCanonicalId = exports.parseExternalId = exports.findAppConfigById = exports.findLinkAppConfig = void 0;
const appHelpers_1 = require("./appHelpers");
const findLinkAppConfig = (url, allLinkAppConfig) => {
    const result = allLinkAppConfig.find((linkAppConfig) => {
        return linkAppConfig.matchKeys.some((matchKey) => {
            const allMatchKeys = matchKey.split("|");
            return allMatchKeys.every((match) => url.includes(match));
        });
    });
    return result ? result : (0, exports.findAppConfigById)("OTHER", allLinkAppConfig);
};
exports.findLinkAppConfig = findLinkAppConfig;
const findAppConfigById = (appId, allLinkAppConfigs) => {
    return allLinkAppConfigs.find((linkAppConfig) => {
        return (linkAppConfig === null || linkAppConfig === void 0 ? void 0 : linkAppConfig.id) && appId
            ? linkAppConfig.id.toLowerCase() === appId.toLowerCase()
            : false;
    });
};
exports.findAppConfigById = findAppConfigById;
const parseExternalId = (url, linkAppConfig) => {
    if (linkAppConfig.matchExternals.length === 0) {
        return;
    }
    if (linkAppConfig.id === "OTHER") {
        return url;
    }
    let result;
    for (const matchRegex of linkAppConfig.matchExternals) {
        const regex = new RegExp(matchRegex);
        const match = url.match(regex);
        if (match && match[1]) {
            console.log("found externalId", match[1]);
            if (!result) {
                result = match[1];
            }
            else {
                result = `${result}:${match[1]}`;
            }
        }
    }
    return result;
};
exports.parseExternalId = parseExternalId;
const createCanonicalId = (url, linkAppConfig) => {
    if (linkAppConfig.matchExternals.length === 0) {
        return linkAppConfig.id + ":" + url;
    }
    const externalId = (0, exports.parseExternalId)(url, linkAppConfig);
    if (!externalId) {
        return linkAppConfig.id + ":" + url;
    }
    return linkAppConfig.id + ":" + externalId;
};
exports.createCanonicalId = createCanonicalId;
const parseUrl = (url) => {
    try {
        return new URL(url);
    }
    catch (err) {
        console.warn(`[linkHelpers/parseUrl] Invalid URL format, trying with https://: ${url}`);
        try {
            // Prepend https:// and retry parsing
            return new URL(`https://${url}`);
        }
        catch (secondErr) {
            console.info(`[linkHelpers/parseUrl] ERROR parsing url ::${url}:: is not valid even after adding https://`);
            return;
        }
    }
};
const getAppFromUrl = (url, allLinkAppConfigs) => {
    const parsedUrl = parseUrl(url);
    if (!parsedUrl) {
        return "NOT_VALID_URL";
    }
    const resultAppConfig = (0, exports.findLinkAppConfig)(url, allLinkAppConfigs);
    if (resultAppConfig) {
        return resultAppConfig;
    }
    const otherApp = (0, exports.findAppConfigById)("OTHER", allLinkAppConfigs ? allLinkAppConfigs : []);
    console.log("[getAppFromUrl] otherApp", otherApp);
    return otherApp !== null && otherApp !== void 0 ? otherApp : "APP_CONFIG_NOT_FOUND";
};
exports.getAppFromUrl = getAppFromUrl;
const getAppFromMimeType = (mimeType, allLinkAppConfigs) => {
    let lac = undefined;
    switch (mimeType) {
        case "application/vnd.google-apps.document":
            lac = (0, exports.findAppConfigById)("GOOGLE_DOC", allLinkAppConfigs);
            break;
        case "application/vnd.google-apps.spreadsheet":
            lac = (0, exports.findAppConfigById)("GOOGLE_SPREADSHEET", allLinkAppConfigs);
            break;
        case "application/vnd.google-apps.presentation":
            lac = (0, exports.findAppConfigById)("GOOGLE_PRESENTATION", allLinkAppConfigs);
            break;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            lac = (0, exports.findAppConfigById)("GOOGLE_DOC", allLinkAppConfigs);
            break;
        case "application/pdf":
            lac = (0, exports.findAppConfigById)("GOOGLE_DOC", allLinkAppConfigs);
            break;
        case "application/rdf":
            lac = (0, exports.findAppConfigById)("GOOGLE_DOC", allLinkAppConfigs);
            break;
        case "application/txt":
            lac = (0, exports.findAppConfigById)("GOOGLE_DOC", allLinkAppConfigs);
            break;
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        case "application/vnd.ms-excel":
            lac = (0, exports.findAppConfigById)("GOOGLE_DOC", allLinkAppConfigs);
            break;
    }
    console.log("[getAppFromMimeType] lac", lac);
    return lac;
};
exports.getAppFromMimeType = getAppFromMimeType;
const getFileExtension = (filename) => {
    return filename.toLowerCase().split(".").pop();
};
exports.getFileExtension = getFileExtension;
const getAppLogo = (appId, title, allLinkAppConfigs, ending) => {
    if (!appId) {
        return "other";
    }
    if (appId === "FILE" && title) {
        const extension = (0, exports.getFileExtension)(title);
        return extension + "-logo.png";
    }
    const index = allLinkAppConfigs.findIndex((linkApp) => {
        return (linkApp === null || linkApp === void 0 ? void 0 : linkApp.id) && appId
            ? linkApp.id.toLowerCase() === appId.toLowerCase()
            : false;
    });
    if (index !== -1) {
        return allLinkAppConfigs[index].logo + (ending ? ending : "");
    }
    return "other";
};
exports.getAppLogo = getAppLogo;
const getAppName = (appId, allLinkAppConfigs) => {
    if (!appId) {
        return "";
    }
    const index = allLinkAppConfigs.findIndex((linkApp) => {
        return (linkApp === null || linkApp === void 0 ? void 0 : linkApp.id) && appId
            ? linkApp.id.toLowerCase() === appId.toLowerCase()
            : false;
    });
    if (index !== -1) {
        return allLinkAppConfigs[index].displayName;
    }
    return "";
};
exports.getAppName = getAppName;
const getLogoFilePath = (logo, background = true) => {
    return "/app_logos/" + logo + "-" + (background ? "bg" : "nobg") + ".svg";
};
exports.getLogoFilePath = getLogoFilePath;
const getLogoFilePathInMode = (logo, background = true, theme = "light-mode") => {
    return ("/icons/" +
        theme +
        "/app_logos/" +
        logo.toLowerCase() +
        "-" +
        (background ? "bg" : "nobg") +
        ".svg");
};
exports.getLogoFilePathInMode = getLogoFilePathInMode;
const getActivityLogoFilePathInMode = (logo, theme = "light-mode") => {
    return "/icons/" + theme + "/app_logos/" + logo;
};
exports.getActivityLogoFilePathInMode = getActivityLogoFilePathInMode;
const getAppLogoFromFilename = (filename) => {
    const extension = (0, exports.getFileExtension)(filename);
    console.log("[getAppLogoFromFilename] extension", extension);
    return extension + "-logo.png";
};
exports.getAppLogoFromFilename = getAppLogoFromFilename;
const getAppLogoFromUrl = (url, allLinkAppConfigs) => {
    try {
        const newLinkAppConfig = (0, exports.getAppFromUrl)(url, allLinkAppConfigs ? allLinkAppConfigs : []);
        if (newLinkAppConfig === "NOT_VALID_URL") {
            return undefined;
        }
        if (newLinkAppConfig === "APP_CONFIG_NOT_FOUND") {
            // (async () => {
            const otherApp = (0, exports.findAppConfigById)("OTHER", allLinkAppConfigs ? allLinkAppConfigs : []);
            if (otherApp) {
                return otherApp.logo;
            }
            // })();
        }
        else {
            return newLinkAppConfig.logo;
        }
    }
    catch (err) {
        console.log("[getAppLogoFromUrl] caugth error: ", err);
    }
    return undefined;
};
exports.getAppLogoFromUrl = getAppLogoFromUrl;
const getAppLogoFromLinkRecord = (linkRecord, allLinkAppConfigs, ending) => {
    // if there is a mime type, that is the definitive
    if (linkRecord.mimeType) {
        const mtLogo = (0, appHelpers_1.getAppLogoFromMimeType)(linkRecord.mimeType);
        if (mtLogo) {
            return mtLogo;
        }
    }
    let logo = "";
    // if its not MSFT then do it the old fashioned qway
    if (!linkRecord.msDriveId) {
        if (linkRecord.links && linkRecord.links.length > 0) {
            logo = (0, exports.getAppLogo)(linkRecord.links[0].appId, linkRecord.links[0].title, allLinkAppConfigs, ending);
        }
    }
    else {
        if (linkRecord.links && linkRecord.links.length > 0) {
            logo = (0, exports.getAppLogoFromFilename)(linkRecord.links[0].title || "");
        }
    }
    return logo;
};
exports.getAppLogoFromLinkRecord = getAppLogoFromLinkRecord;
